import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import transformMessage from './messageTransformer';
import useExtendedSubscription from '../../hooks/useExtendedSubscription';
import { ON_MESSAGE_CHANGED } from '../../graphql/messages';
import {showErrorNotification, showInfoNotification, showWarningNotification} from '../../actions/notifications';
import {createLogger} from "../../utils/logging";

const logger = createLogger('GlobalMessages');

function GlobalMessages() {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    useExtendedSubscription(ON_MESSAGE_CHANGED, {
        dataProperty: 'messageChanged',
        onChangeCallback: ({ model: { messageKey, params, severity } }) => {
            const notification = transformMessage(i18n, messageKey, params);
            switch (severity) {
                case 'INFO':
                    dispatch(showInfoNotification(notification));
                    break;
                case 'WARN':
                    dispatch(showWarningNotification(notification));
                    break;
                case 'ERROR':
                    dispatch(showErrorNotification(notification));
                    break;
                default:
                    logger.error("unknown severity", severity);
                    break;
            }
        },
    });
    return null;
}

export default GlobalMessages;
